import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent, Register } from '@xanadu/core';
import { Realm } from '@xanadu/model';

@Component({
    selector: 'app-realm-panel',
    templateUrl: './realm-panel.component.html',
    styleUrls: ['./realm-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('realm-panel')
export class RealmPanelComponent extends PanelComponent<Realm> {
    private tabRealm = { caption: 'Realm', active: true, hidden: false };

    protected override get nodeType(): string | undefined {
        return 'import';
    }

    protected override setup(realm: Realm): void {
        super.setup(realm);

        this.tabs = [
            this.tabRealm
        ];
        this.tabSelected = this.tabRealm;
    }
}
